import Vue from 'vue';
import VTooltip from 'v-tooltip';

import { router } from './routing';

import App from './App.vue';
import store from './store';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCheckCircle, faTimesCircle, faExclamationCircle, faQuestionCircle, faCheck, faEdit, faTimes, faExclamation, faQuestion, faPlus, faSitemap, faLevelUpAlt, faUserPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import mongoose from 'mongoose';

window.$ = require('jquery');

Vue.prototype.$mouseEventOffset = require('mouse-event-offset');
Vue.prototype.$id = function() {
    return new mongoose.Types.ObjectId().toHexString();
};

library.add(
    faEdit,
    faCheckCircle,
    faTimesCircle,
    faExclamationCircle,
    faQuestionCircle,
    faCheck,
    faTimes,
    faExclamation,
    faQuestion,
    faPlus,
    faUserPlus,
    faSitemap,
    faLevelUpAlt,
);

Vue.component('fa-icon', FontAwesomeIcon);
Vue.config.productionTip = false

Vue.use(VTooltip);

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app')
